"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = selectedChoicesReducer;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _actionTypes = require("../actions/actionTypes");
function selectedChoicesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actionTypes.CLEAR_STATE:
      {
        return [];
      }
    case _actionTypes.UPDATE_SELECTED_CHOICES:
      {
        if (action.selectedChoices) {
          return (0, _toConsumableArray2["default"])(action.selectedChoices);
        }
        return [];
      }
    default:
      return state;
  }
}
//# sourceMappingURL=selectedChoicesReducer.js.map